import { atom } from 'recoil';

export const muteState = atom<boolean>({
  key: 'muteState',
  default: true,
});

export const playState = atom<boolean>({
  key: 'playState',
  default: false,
});

export const playerOpenState = atom<boolean>({
  key: 'playerOpenState',
  default: false,
});

export const notificationOpenState = atom<boolean>({
  key: 'notificationOpenState',
  default: false,
});
export const petOpenState = atom<boolean>({
  key: 'petOpenState',
  default: false,
});


export const musicURLState = atom<string | undefined>({
  key: 'musicURLState',
  default: '',
});

export const musicStartYState = atom<number>({
  key: 'musicStartYState',
  default: 0,
});

// 🎵 페이지별 커스텀 BGM 상태 (전역 BGM보다 우선)
export interface PageBgmState {
  url: string | null;       // 페이지별 BGM URL (null이면 전역 BGM 사용)
  isActive: boolean;        // 페이지 BGM 활성화 여부
  startY?: number;          // 스크롤 후 재생 시작 위치 (선택)
}

export const pageBgmState = atom<PageBgmState>({
  key: 'pageBgmState',
  default: {
    url: null,
    isActive: false,
    startY: 0,
  },
});

// 🎵 전역 BGM 일시정지 상태 (페이지 BGM 재생 시 전역 BGM 일시정지용)
export const globalBgmPausedState = atom<boolean>({
  key: 'globalBgmPausedState',
  default: false,
});

// 🎵 라우트 레벨 BGM 음소거 상태 (특정 페이지에서 BGM 완전 차단용)
// useSetTheme 등 내부 로직의 영향을 받지 않도록 별도 atom으로 관리
export const routeBgmMutedState = atom<boolean>({
  key: 'routeBgmMutedState',
  default: false,
});
